import { Component, HostListener, OnChanges, OnDestroy, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TypeaheadConfig, TypeaheadModule, TypeaheadOrder } from 'ngx-bootstrap/typeahead';
import { CookieService } from 'ngx-cookie-service';
import { Observable, Subject, catchError, debounceTime, distinctUntilChanged, map, of, switchMap } from 'rxjs';
import { workExperienceDetails } from 'src/app/page/model/workexperience-modal/workexperience-modal.component';
import { FormValidation } from 'src/app/services/FormValidation';
import { ApiService } from 'src/app/services/api.service';
import { candidateModel } from 'src/app/services/candidateModel';
import { SearchData } from 'src/app/services/searchData';
import { SocketService } from 'src/app/services/socket.service';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { CustomValidator } from '../../Helper/custom-validator';
import { SocketServiceStream } from './../../../services/SocketServiceStream';
import { GigsumoConstants, USER_TYPE } from 'src/app/services/GigsumoConstants';
import { AppSettings } from 'src/app/services/AppSettings';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { CacheInvalidationService } from 'src/app/services/cache-invalidation.service';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSummernoteModule } from 'ngx-summernote';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

declare var $: any;
@Component({
  selector: 'app-candidates-profile-details',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MatSelectModule, MatAutocompleteModule, NgSelectModule, NgxSummernoteModule,
CommonSkeletonComponent, InfiniteScrollModule, TypeaheadModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './candidates-profile-details.component.html',
  styleUrls: ['./candidates-profile-details.component.scss'],
  // TypeaheadConfig must be provided by the component that uses the typeahead —
  // importing TypeaheadModule alone does NOT supply it (bare import => runtime
  // "NullInjectorError: No provider for TypeaheadConfig!"). Same convention as
  // personal-profile-edit / bussiness-post / langding-page-nav-bar.
  providers: [TypeaheadConfig],
  inputs : ['candidateDetails']
})
export class CandidatesProfileDetailsComponent extends FormValidation implements OnInit , OnChanges, OnDestroy {
  modalRef: BsModalRef;
  public FORMERROR = super.Form;
  userId= localStorage.getItem('userId')
  userType : string =localStorage.getItem('userType');
  CadidateInfo: UntypedFormGroup;
  candidateDetails: candidateModel;
  CadidateWorkExpeiecnceForm: UntypedFormGroup;
  domainForm : UntypedFormGroup
  CadidateEducationForm: UntypedFormGroup;
  CadidateCerificationForm: UntypedFormGroup;
  submitted: boolean = false;
  candidateId: any;
  CandidateData: any;
  FormData: any;
  currentYear: any = new Date().getFullYear();
  submittedWorkexp: boolean = false;
  submittedEducation: boolean = false;
  submittedCertification: boolean = false;
  @ViewChild("businessEmail") businessTemplate;
  businessmodal : BsModalRef
  workExperiences: UntypedFormArray;
  instList : any =[]
  yearData: any;
  yearIndex: any;
  checkWorkModel :string
   editData: any;
  candidateJobTitleList: any = [];
  recruiterTitleList: any = [];
  months: any = [
    { code: 1, name: "January" },
    { code: 2, name: "February" },
    { code: 3, name: "March" },
    { code: 4, name: "April" },
    { code: 5, name: "May" },
    { code: 6, name: "June" },
    { code: 7, name: "July" },
    { code: 8, name: "August" },
    { code: 9, name: "September" },
    { code: 10, name: "October" },
    { code: 11, name: "November" },
    { code: 12, name: "December" },
  ];
  years: any = [];
  countryList: any = [];
  stateList: any = [];
  // Bumped on every loadStatesForCountry() call so an out-of-order getAllStates
  // response (e.g. after quickly switching schools/countries) can be dropped
  // instead of overwriting the list/value for the country now selected.
  stateFetchToken = 0;
  clientTypeList = [];
  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
  };
   sortConfigEdu: TypeaheadOrder = {
    direction: "desc",
    field: "institutionName",
  };
  validateMonth: boolean;
  config2= {
    focus: false,
    height: 150,
    placeholder: "",
    link: [["link", ["linkDialogShow", "unlink"]]],
    insert: ["link", "picture", "video"],
    view: ["fullscreen", "codeview", "help"],
    style: "outline: none !important;background-color: rgb(241 243 246) !important;cursor: pointer !important;",
    disableDragAndDrop: true,
    blockquoteBreakingLevel: 1,
    callbacks: {
      onFocus: function (contents) {
        if ($(this).summernote("isEmpty")) {
          $("#summessage").html("");
        }
      },
      onKeydown: (e) => {
        const text = e.currentTarget.innerText;
        this.updateRemainingCharacters('resumeSummary', text);
      },
      onPaste: (e) => {
        const buffertext = (e.originalEvent || e).clipboardData.getData("text");
        e.preventDefault();
        const words = buffertext.trim().split(/\s+/);
        const limitedText = words.slice(0, 1000).join(' ');
        document.execCommand("insertText", false, limitedText);
        this.updateRemainingCharacters('resumeSummary', limitedText);
      },
      
    },
    toolbar: [
      ["misc", ["codeview", "undo", "redo"]],
      ["font", ["bold", "italic", "underline", "strikethrough", "superscript", "subscript", "clear"]],
      ["fontsize", ["fontname", "fontsize", "color"]],
      ["para", ["style", "ul", "ol", "paragraph", "height"]],
    ],
    fontNames: ["Helvetica", "Arial", "Arial Black", "Comic Sans MS", "Courier New", "Roboto", "Times"],
  };

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (this.searchBarShow) {
      const target = event.target as HTMLElement;
      // Check if click is inside the autocomplete container or suggestion list
      const isInsideAutocomplete = target.closest('.autocomplete-container');
      const isInsideSuggestionList = target.closest('.suggestion-list');
      console.log('isinsideautocomplete', isInsideAutocomplete);
      console.log('isInsideSuggestionList', isInsideSuggestionList);
      
      if (!isInsideAutocomplete && !isInsideSuggestionList) {
        this.searchBarShow = false;
      }
    }
  }

  searchSubject = new Subject<string>();
  constructor(private modalService: BsModalService,  private _socket: SocketService,private _socket_stream: SocketServiceStream, private searchData: SearchData, private cookieService: CookieService, private router : Router,
    private activatedRoute: ActivatedRoute,private gigsumoService: GigsumoService, private api: ApiService, private fb: UntypedFormBuilder, private util: UtilService,
    private cacheInvalidationService: CacheInvalidationService) {
      super();
  }
  workExperience:Array<any>
  amsubmit :boolean= false;
  educationDetails:any;
  certification : any;
  aboutMe :string;
  emptyworkExp:string;
  createdBy: string
  otpEmailSent:boolean = false;
  firstName : string
  lastName : string
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.candidateDetails && changes.candidateDetails.currentValue) {
      const previous = changes.candidateDetails.previousValue;
      const current = changes.candidateDetails.currentValue;
      this.candidateDetails = current;
      this.userType = current.user && current.user.userType;

      // When the parent swaps to a different candidate, clear the previous
      // candidate's profile data and refetch — otherwise work experience,
      // education, and certifications from the prior candidate persist on
      // CandidateData and new entries get pushed onto the stale object,
      // causing cross-candidate data leakage.
      // Trigger API call on first load AND when candidateId changes
      if (!previous || previous.candidateId !== current.candidateId) {
        this.CandidateData = null;
        this.aboutMe = undefined;
        this.emptyworkExp = undefined;
        // Resolve the creator's userType with the same fallback the rest of the
        // app uses: the `user` sub-object is often NOT hydrated on list rows
        // (e.g. "My Candidate"/"My Profile" summary paint) — only the flat
        // `createdByUserType` scalar is reliably present there. Without this
        // fallback a JOB_SEEKER's own candidate wrongly took the candidate-store
        // branch (findCandidateById) instead of user/{createdBy}.
        if (((current.user && current.user.userType) || current.createdByUserType) === GigsumoConstants.JOB_SEEKER) {
          this.getworkexperience();
        } else {
          this.getCandidateDetails();
        }
      }
    }
  }
  ngOnInit() {
    this.gigsumoService.loadMyBusinessId();
    this.aboutUsForm();
    this.workExperiencesformfields();
    this.CadidateEducationFormfiles();
    this.CadidateCerificationFormField();
    this.generateYears();
    this.getCountry();
    this.getTitleList();
    // School typeahead source. Cheap + lazy: it only fires a request when the
    // user actually types (the form value is read at subscribe time), so this
    // does no work on page load.
    this.initSchoolSuggestions();
    this.searchSubject.pipe(
      debounceTime(1000),
      distinctUntilChanged()
    )
      .subscribe(
        res => {
          // this.getOrganization(res);
          // this.patchValue({
          //   country : null ,
          //   state : null ,
          //   city : null,
          //   zipcode : null,
          // })
          // the old logic commented because to follow work-experience-modal logic

          this.organizationList = [];
          this.organizationPayload.page = 0;
          // A new search starts a fresh result set — without this the flag stays
          // true after one exhausted search and infinite scroll never pages again.
          this.orgStopScroll = false;
          this.getOrgList(res);
          this.patchValue({
            country: null,
            state: null,
            city: null,
            zipcode: null,
          })
        }
      )
    this.activatedRoute.queryParams.subscribe((res) => {
      this.candidateId = res.candidateId;
      this.createdBy = res.createdBy;
      this.firstName = res.firstName;
      this.lastName = res.lastName;
    })

    // Added null guard to prevent crash when candidateDetails is undefined
    if ((this.candidateDetails?.user?.userType || this.candidateDetails?.createdByUserType) === GigsumoConstants.JOB_SEEKER) {
      this.getworkexperience();
    } else if (this.candidateDetails?.candidateId) {
      this.getCandidateDetails();
    }

     
  }
 
  ngOnDestroy(): void {
    if (this.searchSubject) {
      this.searchSubject.unsubscribe();
    }
  }

  patchValue(value: Partial<workExperienceDetails>) {
    this.CadidateWorkExpeiecnceForm.patchValue({ ...value });
  }
  // getEducationFormGroup(index) : FormGroup{
  //   const formgroup = this.CadidateEducationForm.controls[index] as FormGroup;
  //   return formgroup;
  // }
  schoolData: any = []
  // Live search term for the School ng-select.
  currentSchoolSearch : string = ''
  edulist() {
   let  data = this.CadidateEducationForm.value.schoolName;
      this.util.startLoader();
    this.api.query("care/intitutions/" + data).subscribe((res) => {
      this.util.stopLoader();
        this.schoolData = res;
        this.CadidateEducationForm.patchValue({
          country : this.schoolData.country,
          state : this.schoolData.state,
          city: this.schoolData.city,
          zipcode : this.schoolData.zipCode,
        });
    }, err => {
      this.util.stopLoader();
    });
  }

  getInstitutions() {
    // NO blocking loader: this is a background list load for the School /
    // College typeahead. The previous version called startLoader() and only
    // stopLoader() *inside* `if (res)` — so a null/empty (or slow) response left
    // the full-page overlay up forever and froze the whole app. It never
    // surfaced before because nothing called this method.
    this.api.query("care/institutions").subscribe((res) => {
      if (res) {
        this.instList = [];
        res.forEach((ele) => {
          var obj: any = {};
          obj.institutionId = ele.institutionId;
          obj.institutionName = ele.institutionName;
          obj.city = ele.city;
          obj.state = ele.state;
          obj.country = ele.country;
          obj.countryName = ele.countryName;
          obj.street = ele.street && ele.street !== null ? ele.street : null;
          this.instList.push(obj);
        });
      }
    }, err => {
      // Swallow: the typeahead just has no suggestions. Never touch the global
      // loader here — this must not be able to block the UI.
      this.instList = [];
    });
  }
  emailPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$";
  getDomainForm(){
    this.domainForm = this.fb.group({
      businessemail : [null, [Validators.required,Validators.email, Validators.pattern(this.emailPattern)]],
      domainValidationOtp :  [null, [Validators.required]],
    })
   }
   defineDomainErrors(){
    // this.domainForm.get('businessemail').setErrors({emailExists : false})
    //  this.domainForm.get('domainValidationOtp').setErrors({wrongOtp : false})
    // )
    // )
    }
    updateOtp(){
    }
  // Get candidate information

  loadAPIcall:boolean=false;
  getCandidateDetails() {
  // this.util.startLoader();
   this.loadAPIcall=true;

    this.api.query("candidates/findCandidateById/" + this.candidateDetails.candidateId).subscribe(res => {
      if (res.code == '00000') {
        // this.util.stopLoader()
        this.loadAPIcall=false;

        this.CandidateData = res.data.candidateData;
        this.sortCandidateData();
        if(this.CandidateData.resumeSummary== null || undefined || this.CandidateData.resumeSummary== "<p><br></p>" || this.CandidateData.resumeSummary== "<br>"){
          this.CandidateData.resumeSummary ="About candidate has not been provided";
        }
     
        
      }
    })
  }
 
  
previousMailId : string
  getworkexperience(){
    //  this.util.startLoader();
    let userId = this.candidateDetails.createdBy;
    this.loadAPIcall=true;
       this.api.query("user/" + userId).subscribe(res => {
        this.loadAPIcall=false;
        this.previousMailId = res.email;
        let data : any ={}
        data = res;
        // workExperience for Jobseeker and student
        let workExp : Array<any> = res.workExperience;
        if(res.aboutMe == null || res.aboutMe == "") {
          this.aboutMe =  this.candidateDetails.createdBy === this.userId ? "You haven't added any details yet" : "About candidate has not been provided";
        }
        else{
          this.aboutMe =res.aboutMe;
        }

        if((workExp == null || undefined) || workExp.length==0) { this.emptyworkExp = "You haven't added any  details yet";}
        else{
          data.workExperiences =  res.workExperience;
          this.CandidateData= data;
        }
        data.educationDetails = res.educationDetail;
        data.aboutMe = res.aboutMe;
        data.candidateCertifications = res.certification;

        this.CandidateData= data;
        this.sortCandidateData();

        this.util.stopLoader();
      });
  }
  private monthOrder = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  private sortByStartDate(arr: any[]): any[] {
    if (!arr || arr.length === 0) return arr;
    return arr.sort((a, b) => {
      // Current organization should come first
      if (a.currentOrganization && !b.currentOrganization) return -1;
      if (!a.currentOrganization && b.currentOrganization) return 1;

      // Then sort by year descending
      const yearDiff = (b.startYear || 0) - (a.startYear || 0);
      if (yearDiff !== 0) return yearDiff;
      const aMonth = this.monthOrder.indexOf(a.startMonth) ?? -1;
      const bMonth = this.monthOrder.indexOf(b.startMonth) ?? -1;
      return bMonth - aMonth;
    });
  }

  /** year + month → one sortable number (`year * 100 + monthIndex`), so the year
   *  always dominates the month.
   *
   *  Missing / unparsable dates return a sentinel that sorts FIRST in the
   *  descending order below — deliberate: a row with no end date is the most
   *  recent one. Returning NaN here would poison the comparator and corrupt the
   *  whole ordering. Kept identical to candidate-profile-slider so both surfaces
   *  render the same order. */
  private toSortableDate(year: any, month: any): number {
    const y = parseInt(year, 10);
    if (isNaN(y)) { return Number.MAX_SAFE_INTEGER; }
    const m = this.monthOrder.indexOf(month);
    return y * 100 + (m >= 0 ? m : 0);
  }

  /** Education ordered MOST-RECENT-FIRST by the "To" (end) date — the LinkedIn /
   *  Naukri convention, and the same comparator the candidate slider uses.
   *  e.g. MCS (…2026) → BSC (…2018) → 12th (…2017).
   *
   *  Sorted on dates, NOT the degree text: `degree` is free-text (no dropdown),
   *  so it can't be ranked reliably — "B.Tech", "Bachelor of Science" and
   *  "Licenciatura" are one tier, and keyword matching misfires ("ba" also hits
   *  "MBA"). Education is sequential, so the end date reproduces the degree
   *  hierarchy for free, in any country.
   *
   *  The END date is the key, not the start: a 12th row starting 2016 would
   *  otherwise jump above a BSC that started 2014 but finished 2018 — which is
   *  exactly what the generic sortByStartDate() did here.
   *
   *  "Currently Pursuing" is pinned to the top via an EXPLICIT flag check, not
   *  "has no end date": the education save does NOT null endMonth/endYear when
   *  currentlyPursued is ticked, so a "Present" row can carry a stale end date
   *  and would otherwise sink to the bottom while displaying "Present". */
  private sortEducationDetails(arr: any[]): any[] {
    if (!arr || arr.length === 0) return arr;
    return arr.sort((a, b) => {
      const aCurrent = a?.currentlyPursued === true || a?.currentlyPursued === 'true';
      const bCurrent = b?.currentlyPursued === true || b?.currentlyPursued === 'true';
      if (aCurrent !== bCurrent) { return aCurrent ? -1 : 1; }
      // Descending (b - a) → latest completion first.
      const endDiff = this.toSortableDate(b?.endYear, b?.endMonth)
        - this.toSortableDate(a?.endYear, a?.endMonth);
      if (endDiff !== 0) { return endDiff; }
      // Same end → whichever started later comes first.
      return this.toSortableDate(b?.startYear, b?.startMonth)
        - this.toSortableDate(a?.startYear, a?.startMonth);
    });
  }

  private sortCandidateData() {
    if (!this.CandidateData) return;
    if (this.CandidateData.workExperiences) {
      this.CandidateData.workExperiences = this.sortByStartDate(this.CandidateData.workExperiences);
    }
    if (this.CandidateData.educationDetails) {
      this.CandidateData.educationDetails = this.sortEducationDetails(this.CandidateData.educationDetails);
    }
    if (this.CandidateData.candidateCertifications) {
      this.CandidateData.candidateCertifications = this.sortByStartDate(this.CandidateData.candidateCertifications);
    }
  }

  // All Form
  aboutUsForm() {
    this.CadidateInfo = this.fb.group({
      resumeSummary: [
        '',
        Validators.compose([
          this.companyMinMaxCharacters(this.PITCH.min, this.ABOUT_ME.max),
        ]),
      ],
    });
    this.CadidateInfo.get('resumeSummary')?.valueChanges.subscribe((value) => {
      this.amsubmit=false
      this.updateRemainingCharacters('resumeSummary', value || '');
    });
  }
  workExperiencesformfields() {

    if(this.userType === "JOB_SEEKER"){
      this.CadidateWorkExpeiecnceForm = new AppSettings().getWorkExperienceForm();
    }
    else{
      this.CadidateWorkExpeiecnceForm = this.fb.group({
        title: [null, [Validators.required]],
        organisationName: [null, [Validators.required,CustomValidator.checkWhiteSpace() ,CustomValidator.max(this.ORGANIZATION_NAME.max)],],
        organisationId: [null],
        clientType: [null, [Validators.required]],
        expId: [null],
        userId: [null],
        currentOrganization: [false],
        startMonth: [null, [Validators.required]],
        startYear: [this.currentYear, [Validators.required]],
        endMonth: [null, [Validators.required]],
        endYear: [this.currentYear, [Validators.required]],
        state: [null, [Validators.required, CustomValidator.max(this.STATE.max)]],
        city: [null, [Validators.required , CustomValidator.max(this.CITY.max)]],
        zipcode: [null, [Validators.required , CustomValidator.minmaxLetters(this.ZIPCODE.min,this.ZIPCODE.max)]],
        badge: [false],
        country: [null, [Validators.required]],
      });
    }

  }
  CadidateCerificationFormField() {
    this.CadidateCerificationForm = this.fb.group({
      certificationName: [null, Validators.required],
      certificateOrganization: [null, Validators.required],
      certificateLicenseNo: [null, Validators.required],
      startMonth: [null, [Validators.required]],
      startYear: [this.currentYear, [Validators.required]],
      endMonth: [null, [Validators.required]],
      endYear: [this.currentYear, [Validators.required]],
      certificateId: [null],
      userId: [null]
    })
  }
  CadidateEducationFormfiles() {
    this.CadidateEducationForm = this.fb.group({
      schoolName: [null, [Validators.required , CustomValidator.minmaxLetters(this.SCHOOL_NAME.min , this.SCHOOL_NAME.max)]],
      institutionId: [null],
      eduId: [null],
      userId: [null],
      degree: [null, [Validators.required]],
      showThisOnProfile: [false],
      currentlyPursued: [false],
      startMonth: [null, [Validators.required]],
      startYear: [this.currentYear, [Validators.required]],
      endMonth: [null, [Validators.required]],
      endYear: [this.currentYear, [Validators.required]],
      city: [null, [Validators.required, CustomValidator.max(this.CITY.max)]],
      street: [null, [Validators.required]],
      state: [null, [Validators.required, CustomValidator.max(this.STATE.max)]],
      zipcode: [null, [Validators.required, CustomValidator.minmaxLetters(this.ZIPCODE.min,this.ZIPCODE.max)]],
      country: [null, [Validators.required]],
      speciality: [null, [Validators.required]],
    })
  }

  // Fired on every keystroke in the Organisation input. Editing the name means
  // a DIFFERENT / new organisation, so drop the linked id (the backend registers
  // a new organisation when organisationId is null) and UNLOCK the location for
  // manual entry — an org picked from the list locks it again in onChangeorg().
  manageOrgList(value) {
    if (this.workFromControl.organisationId.value) {
      this.workFromControl.organisationId.setValue(null);
      this.setWorkLocationEditable(true);
    }
    this.searchSubject.next(value);
  }

  // Formcontrols
  get candidateRequsetControls() {
    return this.CadidateInfo.controls
  }
  get workFromControl() {
    return this.CadidateWorkExpeiecnceForm.controls
  }
  get educationFormControl() {
    return this.CadidateEducationForm.controls
  }
  get CerificationControl() {
    return this.CadidateCerificationForm.controls
  }
  // model for modelResumeSummary
  modelResumeSummary(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg' ,backdrop: 'static', keyboard: false});
    if(this.userType == 'student' || this.userType == 'JOB_SEEKER') {
      this.CadidateInfo.patchValue({ 'resumeSummary': this.CandidateData.aboutMe })
    }
    else  this.CadidateInfo.patchValue({ 'resumeSummary': this.CandidateData.aboutCandidate })
  }
  closeModal(): void {
    this.CadidateInfo.reset();
    this.CadidateInfo.markAsPristine();
    this.CadidateInfo.markAsUntouched();
    this.modalService.hide(1);
    this.amsubmit = false;
  }
  savemodalRef : BsModalRef;
  // model for modelResumeSummary
  modelWorkExperience(template: TemplateRef<any>,value) {
    this.checkWorkModel = value
    this.CadidateWorkExpeiecnceForm.reset();
    // Opening the "add" form: there is no entry being edited, so clear any
    // stale editData left over from a previous edit/remove. Otherwise a new
    // save inherits that entry's expId and the duplicate-current guard
    // wrongly excludes the existing current entry, creating a duplicate.
    this.editData = undefined;
    this.submittedWorkexp = false;
    // Fresh add — clear any org suggestions left from a previous edit so the
    // Organisation typeahead starts empty.
    this.organizationList = [];
    // No org picked yet → location stays editable until an existing org is chosen
    // (which locks it); also re-enable in case a previous edit left it disabled.
    this.setWorkLocationEditable(true);
    this.savemodalRef = this.modalService.show(template, { class: 'modal-md' });
    this.CadidateWorkExpeiecnceForm.patchValue({
      endYear: this.currentYear,
      startYear: this.currentYear,
    });
    // this.CadidateWorkExpeiecnceForm.patchValue({ 'resumeSummary': this.CandidateData.resumeSummary })
  }
  modelEducation(template: TemplateRef<any>,val) {
    this.checkEduMOdel=val;
    this.CadidateEducationForm.reset();
    this.submittedEducation = false;
    // Fresh add — clear any school suggestions/seed left from a previous edit.
    this.schoolData = [];
    this.currentSchoolSearch = '';
    // No institution picked yet (don't inherit a previous entry's selection).
    this.selectedInstitutionName = null;
    // No college chosen yet → location stays editable until an existing one is
    // picked (which locks it) — and re-enable in case a previous edit left the
    // controls disabled.
    this.setEducationLocationEditable(true);
    this.modalRef = this.modalService.show(template, { class: 'modal-md' });
    this.CadidateEducationForm.patchValue({
      endYear: this.currentYear,
      startYear: this.currentYear,
      // "Show this education in Profile" defaults to ON for a NEW entry —
      // the reset() above clears the control to null, so it has to be set
      // back here. Edit (`eduEdit`) patches from the saved record instead,
      // so an existing entry keeps whatever the user chose.
      showThisOnProfile: true,
    });
    // this.CadidateEducation.patchValue({ 'resumeSummary': this.CandidateData.resumeSummary })
  }
   modelCertification(template: TemplateRef<any>,val) {
    this.CadidateCerificationForm.reset();
    this.checkcertificationmodel =val;
    this.submittedCertification = false;
    // Opening the "add" form: there is no entry being edited, so clear any
    // stale editData left over from a previous edit. Otherwise the save-branch
    // stamps that entry's certificateId onto the new record's payload and the
    // backend returns the SAME id, so two certs collide on one id (both rows
    // then update together). Mirrors modelWorkExperience / modelEducation.
    this.editData = undefined;
    this.modalRef = this.modalService.show(template, { class: 'modal-md' });
    this.CadidateCerificationForm.patchValue({
      endYear: this.currentYear,
      startYear: this.currentYear,
    });
    // this.CadidateCerification.patchValue({ 'resumeSummary': this.CandidateData.resumeSummary })
  }
   curOrg(event){

    if(event.target.checked){
      this.CadidateWorkExpeiecnceForm.get('endMonth').clearValidators();
      this.CadidateWorkExpeiecnceForm.get('endYear').clearValidators();
      this.CadidateWorkExpeiecnceForm.updateValueAndValidity();
    }
    else if(!event.target.checked){
      this.CadidateWorkExpeiecnceForm.get('endMonth').setValidators([Validators.required]);
      this.CadidateWorkExpeiecnceForm.get('endYear').setValidators([Validators.required]);
      this.CadidateWorkExpeiecnceForm.updateValueAndValidity();
    }

    console.log("updated form" , this.CadidateWorkExpeiecnceForm);
    

  }
  changeEduOrg(event){
    if(event.target.clicked==true){
        this.CadidateEducationForm.value.currentlyPursued = true;
        this.CadidateEducationForm.get('currentlyPursued').setValidators(Validators.required);
        this.CadidateEducationForm.get('currentlyPursued').updateValueAndValidity();
     }
    else if(event.target.clicked==false){
      this.CadidateEducationForm.value.currentlyPursued = false;
    }
  }
  saveAboutMe() {
    const cleanedValue = this.CadidateInfo.controls.resumeSummary.value
    .replace(/<(p|div|span)>\s*(<br>)?\s*<\/\1>/g, '')
    .replace(/<br\s*\/?>/g, '')
    .replace(/&nbsp;/g, '')
    // This regex removes all HTML tags, keeping only plain text by naaz.
    // .replace(/<[^>]+>/g, '')
    .trim();
  this.amsubmit = !cleanedValue;
    if (this.CadidateInfo.valid && cleanedValue) {
      let data: any = {}
      data = this.CandidateData;
      const cleanedContent = cleanedValue.replace(/<img[^>]*>/g, '');
      data.aboutMe=cleanedContent;
      this.util.startLoader();
      this.api.create('user/saveUser', data).subscribe(res => {
        if (res) {
          this.util.stopLoader();
          this.aboutMe = res.aboutMe;
          this.modalRef.hide();
        }
      });
    }
  }



saveaboutUS() {
  this.CadidateInfo.markAllAsTouched();
  const cleanedValue = this.CadidateInfo.controls.resumeSummary.value
  .replace(/<(p|div|span)>\s*(<br>)?\s*<\/\1>/g, '')
  .replace(/<br\s*\/?>/g, '')
  .replace(/&nbsp;/g, '')

  // This regex removes all HTML tags, keeping only plain text by naaz.
  // .replace(/<[^>]+>/g, '')
  .trim();
  this.amsubmit = !cleanedValue;

  if (this.userType == 'JOB_SEEKER') {
    this.saveAboutMe();
  } else {
    if (this.CadidateInfo.valid && cleanedValue) {
      this.modalRef.hide();
      const cleanedContent = cleanedValue.replace(/<img[^>]*>/g, '');
      this.CandidateData.aboutCandidate = cleanedContent;
      this.CandidateData.candidateReferenceId = this.CandidateData.candidateId;
      if (localStorage.getItem('MemberShipType') !== 'Free') {
        this.CandidateData.businessId = localStorage.getItem('myBusinessId') || null;
      }
      this.FormData = new FormData();
      this.FormData.append("candidate", new Blob([JSON.stringify(this.CandidateData)], { type: "application/json" }));

      this.util.startLoader();
      this.api.updatePut('candidates/updateCandidate', this.FormData).subscribe(res => {
        this.util.stopLoader();
      });
    }
  }
}



  close(){
    if(this.checkWorkModel=="save"){
      this.savemodalRef.hide();
    }
    else if ( this.checkWorkModel=="edit"){
      this.modalRef.hide();
    }
  }
  // work experience
  getTitleList() {
    var data = { 'domain': 'GIGSUMO_JOB_TITLE,GIGSUMO_RECRUITERS_TITLE_LIST,JOB_CLIENT_TYPES' }
    this.util.startLoader()
    this.loadAPIcall=true;
    this.api.create('listvalue/findbyList', data).subscribe(res => {
      this.loadAPIcall=false;
      if (res.code == '00000') {
        this.util.stopLoader();
        res.data.JOB_CLIENT_TYPES.listItems.forEach(ele => {
          this.clientTypeList.push(ele.item);
        });
        res.data.GIGSUMO_JOB_TITLE.listItems.forEach(ele => {
          this.candidateJobTitleList.push(ele.item)
        })
        res.data.GIGSUMO_RECRUITERS_TITLE_LIST.listItems.forEach(ele => {
          this.recruiterTitleList.push(ele.item)
        })
      }
    })
  }
  generateYears() {
    var max = new Date().getFullYear();
    var min = max - 80;
    this.years = [];
    for (var i = min; i <= max; i++) {
      this.years.push(i);
    }
  }
  getCountry() {
    this.util.startLoader();
    this.api.query("country/getAllCountries").subscribe((res) => {
      if (res) {
        this.util.stopLoader();
        res.forEach((ele) => {
          this.countryList.push(ele);
        });
      }
    }, err => {
      this.util.stopLoader();
    });
  }
  onChangeCountry(event, value) {
    // Changing Country invalidates whatever State was chosen/typed for the old
    // country — its options no longer apply. Clear State on the SAME form whose
    // Country changed ('work' → Work Experience, otherwise Education) so it falls
    // back to its "State" placeholder until the user picks/types a new one.
    // setValue(null) covers BOTH renderings of the State field: the <select>
    // (null selects the [ngValue]="null" "State" option) AND the free-text
    // <input> shown when the country has no state list — null writes as an empty
    // value there, so its placeholder="State" shows. That <input> is also what's
    // on screen for the moment after this runs, while stateList is [] and the new
    // country's states are still loading.
    const targetForm = value === 'work' ? this.CadidateWorkExpeiecnceForm : this.CadidateEducationForm;
    targetForm.get('state')?.setValue(null);
    this.loadStatesForCountry(event, true);
  }

  /** Load the shared `stateList` (the State <select>'s options) for a country.
   *  Used by BOTH the Country <select> (change) handler AND the school-select
   *  auto-fill path. The latter sets `country` via patchValue, which does NOT
   *  fire the DOM (change) event, so without this the State dropdown kept the
   *  previously-loaded country's states — switching e.g. an India college to a
   *  US one left the US state matching no option (blank field, lost placeholder).
   *  `manageLoader` gates the global loader so the silent auto-fill path (often
   *  already inside a loader) doesn't unbalance it.
   *
   *  When `candidateState`/`targetForm` are passed (the auto-fill paths), the
   *  State VALUE is reconciled ONLY AFTER the options arrive: the incoming state
   *  is applied only if it actually exists in the loaded list (so e.g. a school
   *  record carrying US + "Tamilnadu" won't set a value the US <select> has no
   *  option for, which would blank the field). No match → null, so the "State"
   *  placeholder shows. If the country has no states at all the field is the
   *  free-text <input>, where the raw value is kept as typed. Callers that only
   *  refresh the options (manual Country change) omit `targetForm` and manage the
   *  value themselves. */
  private loadStatesForCountry(
    countryCode: any,
    manageLoader = false,
    candidateState: string | null = null,
    targetForm: UntypedFormGroup | null = null,
  ): void {
    this.stateList = [];
    const myToken = ++this.stateFetchToken;
    const norm = (s: any) => (s || '').toString().trim().toLowerCase();
    if (!countryCode) {
      // No country → no dropdown to validate against; the field is the free-text
      // <input>, so keep the incoming value as-is (or null).
      if (targetForm) { targetForm.get('state')?.setValue(candidateState || null); }
      return;
    }
    if (manageLoader) { this.util.startLoader(); }
    this.api
      .query("country/getAllStates?countryCode=" + countryCode)
      .subscribe((res) => {
        // Drop a stale response for a country that's no longer selected.
        if (myToken !== this.stateFetchToken) { return; }
        this.stateList = Array.isArray(res) ? res : [];
        if (targetForm) {
          if (this.stateList.length) {
            // <select> renders: only patch a value the list actually contains.
            const match = candidateState
              ? this.stateList.find((s: any) => norm(s.stateName) === norm(candidateState))
              : null;
            targetForm.get('state')?.setValue(match ? match.stateName : null);
          } else {
            // No states → free-text <input>: keep the raw value.
            targetForm.get('state')?.setValue(candidateState || null);
          }
        }
        if (manageLoader) { this.util.stopLoader(); }
      }, err => {
        if (myToken === this.stateFetchToken) { this.stateList = []; }
        if (manageLoader) { this.util.stopLoader(); }
      });
  }
  resenOtp : boolean = false;
  requestAnotherOTP(){
    let data : any ={}
    data.email = this.domainForm.value.businessemail;
    data.fristName = this.firstName
    data.lastName = this.lastName
    data.userId = this.userId
    this.newPrimaryEmail= this.domainForm.value.businessemail
     this.api.create("user/sendOtpToMailId",data).subscribe(res=>{
      if(res.code=="00000"){
        this.checkotpEmailSent = true;
        this.resenOtp = true;
      }
      else if(res.code=="99998"){
            this.checkotpEmailSent = false
             this.resenOtp = false
            Swal.fire({
              title:"Email Already Exists",
              text:"use different email to proceed",
              icon:"info",
              timer:2000
            })
        }
    })
  }
  digitKeyOnly(e) {
    var keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
    if ((keyCode >= 37 && keyCode <= 40) || (keyCode == 8 || keyCode == 9 || keyCode == 13) || (keyCode >= 48 && keyCode <= 57)) {
      return true;
    }
    return false;
  }
  decline(): void {
    this.modalRef.hide();
  }
  closeBusiness(){
    this.checkotpEmailSent = false
    this.businessmodal.hide();
  }
  /*  API call & Data Save */
  //  work experience
  emailValidationWorkExperience : boolean = false;
  workExperSave() {
    this.CadidateWorkExpeiecnceForm.markAllAsTouched();

    if(this.userType == 'student' || this.userType == 'JOB_SEEKER') {
      let dataPost: any = {};
      if(this.checkWorkModel=='save') {
         this.submittedWorkexp = true;
       if (this.CadidateWorkExpeiecnceForm.valid) {
         this.util.startLoader();
          // getRawValue() so disabled (locked) location fields stay in the payload.
          dataPost = this.CadidateWorkExpeiecnceForm.getRawValue();
           dataPost.userId = this.userId;
           this.savemodalRef.hide();
           this.util.stopLoader()
             this.api.create('user/v1/workexperience', dataPost).subscribe((res) => {
               if(res.code=="00000"){
                   // Invalidate user cache so profile page shows fresh data
                   this.cacheInvalidationService.invalidateCurrentUserCache();
                   if(res.data.experience!=null)
                  {
                    let data : any ={};
                    data = res.data.experience;
                    this.CandidateData.workExperiences.push(data)
                    this.CandidateData.workExperiences = this.sortByStartDate(this.CandidateData.workExperiences);
                  }
                   this.showDetailSaveSuccess('Work experience added successfully');
             }
             else if(res.code=="99998"){
               this.util.stopLoader();
               const swalWithBootstrapButtons = Swal.mixin({
                 customClass: {
                   confirmButton: "btn btn-success",
                   denyButton: 'btn btn-danger'
                 },
                 buttonsStyling: false,
               });
               swalWithBootstrapButtons
                 .fire({
                   title: "Oops..",
                   text: "You already have a current organization. Changing your current organization to a new work place requires you to authenticate a new business email address for the organization. Would you like to proceed?",
                   icon: "info",
                   showDenyButton: true,
                   confirmButtonText: "Yes",
                   denyButtonText: "No"
                 }).then((result)=>{
                   if(result.isConfirmed){
                     this.getDomainForm();
                     this.savemodalRef.hide();
                     this.domainForm.get('businessemail').setErrors({emailExists : false})
                     this.domainForm.get('domainValidationOtp').setErrors({wrongOtp : false})
                       let ngbModalOptions: NgbModalOptions = { backdrop : 'static', keyboard : false};
                       this.businessmodal = this.modalService.show(this.businessTemplate,ngbModalOptions)
                   }
                 });
             }
             else if (res.code=="10002"){
               Swal.fire({
                 text: "You are the super admin of the business page. You have to transfer super admin rights to other members before changing your current organization.",
                 title: "Cannot change current organization",
                 icon: "error",
                 confirmButtonText: "Ok",
               })
             }
       })
        }
     }
     else if(this.checkWorkModel=='edit') {
       this.submittedWorkexp = true;
       if (this.CadidateWorkExpeiecnceForm.valid) {
         this.util.startLoader();
         let dataPost: any = {};
          // getRawValue() so disabled (locked) location fields stay in the payload.
          dataPost = this.CadidateWorkExpeiecnceForm.getRawValue();
           if (this.editData != undefined) {
             dataPost.expId = this.editData.expId;
             dataPost.candidateId = this.editData.candidateId;
           }


           this.util.stopLoader()
           this.api.updatePut('user/v1/workexperience', dataPost).subscribe((res) => {
             if(res.code==="00000"){
              // Invalidate user cache so profile page shows fresh data
              this.cacheInvalidationService.invalidateCurrentUserCache();
              this.modalRef.hide();
                  this.CandidateData.workExperiences.forEach((element,i) => {
                   if(element.expId==this.editData.expId){
                       // getRawValue() so the refreshed card includes the locked location.
                       this.CandidateData.workExperiences[i] = this.CadidateWorkExpeiecnceForm.getRawValue();
                   }
                 });
                 this.CandidateData.workExperiences = this.sortByStartDate(this.CandidateData.workExperiences);
                 this.showDetailSaveSuccess('Work experience updated successfully');
             }
             else if(res.code==="99998"){
              this.modalRef.hide();
              this.util.stopLoader();
              const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success",
                  denyButton: 'btn btn-danger'
                },
                buttonsStyling: false,
              });
              swalWithBootstrapButtons
                .fire({
                  title: "Oops..",
                  text: "You already have a current organization. Changing your current organization to a new work place requires you to authenticate a new business email address for the organization. Would you like to proceed?",
                  icon: "info",
                  showDenyButton: true,
                  confirmButtonText: "Yes",
                  denyButtonText: "No"
                }).then((result)=>{
                  if(result.isConfirmed){
                    this.getDomainForm();
                    this.savemodalRef.hide();
                    this.domainForm.get('businessemail').setErrors({emailExists : false})
                    this.domainForm.get('domainValidationOtp').setErrors({wrongOtp : false})
                      let ngbModalOptions: NgbModalOptions = { backdrop : 'static', keyboard : false};
                      this.businessmodal = this.modalService.show(this.businessTemplate,ngbModalOptions)
                  }
                });
            }
             else if (res.code==="10002"){
               Swal.fire({
                 text: "You are the super admin of the business page. You have to transfer super admin rights to other members before changing your current organization.",
                 title: "Cannot change current organization",
                 icon: "error",
                 confirmButtonText: "Ok",
               })
              }
             else if(res.code==="99996"){
              Swal.fire({
                title: "Oops..",
                text: "Sorry, one current organization is at least needed for your user type.",
                icon: "error",
                 confirmButtonText: "Ok",
               })
             }
       })
       }
     }
     else if(this.checkWorkModel='saveAfterOtp'){
       dataPost = this.CadidateWorkExpeiecnceForm.getRawValue();
     dataPost.action ="APPROVED";
     dataPost.userId = this.userId;
     dataPost.badge = false;
     dataPost.endMonth = null;
     this.api.create('user/v1/workexperience', dataPost).subscribe((res) => {
       if(res.code=="00000"){
         // Invalidate user cache so profile page shows fresh data
         this.cacheInvalidationService.invalidateCurrentUserCache();
         this.savemodalRef.hide();
         this.businessmodal.hide();
           Swal.fire({
           title: "Work Experience Updated",
           text: "Changes made successfully and your work experience is updated. You will be logged out now. Please login again with the new business email credential.",
           icon: "success",
           timer: 2000,
           showCancelButton: false,
           showConfirmButton: false
         }).then(()=>{
           this.onLogout();
         })
     }
     });
     }
    }
    else{
      this.candidateWorkExp();
    }
}
  zipCodeValidaiton(x : number) : boolean{
    if(String(x).length > 10){
      return false;
    }
    return true;
  }

  /** Auto-dismissing success confirmation shown after Work Experience /
   *  Education details are saved (add or edit). These flows previously updated
   *  the list silently, so the save succeeded but the user got no confirmation.
   *  Mirrors the success-toast style already used in this component. */
  private showDetailSaveSuccess(message: string): void {
    Swal.fire({
      title: message,
      icon: 'success',
      timer: 2000,
      showConfirmButton: false,
      showCancelButton: false,
    });
  }

candidateWorkExp(){

  if(this.checkWorkModel=='save'){
    this.submittedWorkexp = true;

  if (this.CadidateWorkExpeiecnceForm.valid) {
    let dataPost: any = {};
    // getRawValue(): the location controls are disabled (locked) when an existing
    // organisation is picked, and disabled controls are omitted from `.value` —
    // which would silently drop country/state/city/zipcode from the payload.
    dataPost = this.CadidateWorkExpeiecnceForm.getRawValue();
    dataPost.candidateId = this.candidateDetails.candidateId;
    dataPost.streamAction = "ADD";
       if (this.editData != undefined) {
        dataPost.expId = this.editData.expId;
        dataPost.candidateId = this.editData.candidateId;
       }
      if (this.hasDuplicateCurrentWorkExp(dataPost)) {
        return;
      }
      this.util.startLoader()
      // Clear endMonth and endYear if currentOrganization is true
      if (dataPost.currentOrganization === true) {
        dataPost.endMonth = null;
        dataPost.endYear = null;
      }
      // Convert year fields to strings
      if (dataPost.startYear) dataPost.startYear = String(dataPost.startYear);
      if (dataPost.endYear) dataPost.endYear = String(dataPost.endYear);

      this.savemodalRef.hide();
      this.api.updatePut('candidates/updateCandidateWorkExperience', dataPost).subscribe((res) => {
        this.util.stopLoader()
        this.CandidateData.workExperiences.push(res.data.candiateExperience);
        this.CandidateData.workExperiences = this.sortByStartDate(this.CandidateData.workExperiences);
        this.showDetailSaveSuccess('Work experience added successfully');
       })
  }
  }
  else if (this.checkWorkModel=='edit'){
    this.submittedWorkexp = true;
  if (this.CadidateWorkExpeiecnceForm.valid) {
    let dataPost: any = {};
       if (this.editData != undefined) {
        // getRawValue() so disabled (locked) location fields stay in the payload.
        dataPost = this.CadidateWorkExpeiecnceForm.getRawValue();
        dataPost.expId = this.editData.expId;
        dataPost.candidateId = this.editData.candidateId;
      }
      dataPost.streamAction = "ADD";
      if (this.hasDuplicateCurrentWorkExp(dataPost)) {
        return;
      }
      this.util.startLoader()
      // Clear endMonth and endYear if currentOrganization is true
      if (dataPost.currentOrganization === true) {
        dataPost.endMonth = null;
        dataPost.endYear = null;
      }
      // Convert year fields to strings
      if (dataPost.startYear) dataPost.startYear = String(dataPost.startYear);
      if (dataPost.endYear) dataPost.endYear = String(dataPost.endYear);

      this.modalRef.hide();
      this.api.updatePut('candidates/updateCandidateWorkExperience', dataPost).subscribe((res) => {
        this.util.stopLoader()
        this.CandidateData.workExperiences.forEach((element,i) => {
          if(element.expId==this.editData.expId){
            this.CandidateData.workExperiences[i] = res.data.candiateExperience;
          }
        });
        this.CandidateData.workExperiences = this.sortByStartDate(this.CandidateData.workExperiences);
        this.showDetailSaveSuccess('Work experience updated successfully');
       })
  }
  }
}
hasDuplicateCurrentWorkExp(dataPost: any): boolean {
  const isCurrent = (v: any) => v === true || v === 'true';
  if (!isCurrent(dataPost?.currentOrganization)) {
    return false;
  }
  const existing = (this.CandidateData?.workExperiences || []).some(
    (exp: any) => isCurrent(exp?.currentOrganization) && exp?.expId !== dataPost.expId
  );
  if (existing) {
    Swal.fire({
      title: "Only one current work experience is allowed",
      text: "Please uncheck 'Current Organization' on the existing one before marking this as current.",
      icon: "warning",
      confirmButtonText: "Okay",
    });
    return true;
  }
  return false;
}
checkotpEmailSent : boolean = false;
newPrimaryEmail : string
emailvalid :string
proceedAfterValidation(){
  const email = this.domainForm.value.businessemail
  // const emailpattern : RegExp = ^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$;
  const expression: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const result: boolean = expression.test(email)
  if(result){
    let data : any ={}
    data. email= this.domainForm.value.businessemail;
    data.fristName = this.firstName
    data.lastName = this.lastName
    data.userId = this.userId
    this.newPrimaryEmail= this.domainForm.value.businessemail
     this.api.create("user/sendOtpToMailId",data).subscribe(res=>{
      if(res.code=="00000"){
        this.checkotpEmailSent = true;
      }
      else if(res.code=="99998"){
            this.checkotpEmailSent = false
            Swal.fire({
              title:"Email Already Exists",
              text:"use different email to proceed",
              icon:"info",
              timer:2000
            })
        }
    })
  }
  else {
    this.emailvalid ="Enter a Valid Email"
  }
}
  monthChange(val) {
    if (val == "exp") {
      var a: any = this.CadidateWorkExpeiecnceForm.value.startYear;
      var b: any = this.CadidateWorkExpeiecnceForm.value.endYear;
      if (a == b) {
        this.CadidateWorkExpeiecnceForm.patchValue({
          endMonth: null,
        });
      }
    } else if (val == "edu") {
      var a: any = this.CadidateEducationForm.value.startYear;
      var b: any = this.CadidateEducationForm.value.endYear;
      if (a == b) {
        this.CadidateEducationForm.patchValue({
          endMonth: null,
        });
      }
    } else if (val == "cert") {
      var a: any = this.CadidateCerificationForm.value.startYear;
      var b: any = this.CadidateCerificationForm.value.endYear;
      if (a == b) {
        this.CadidateCerificationForm.patchValue({
          endMonth: null,
        });
      }
    }
  }
  checkMonth1(m, val) {
    if (val == "exp") {
      var n = new Date().getMonth();
      var maxYear = new Date().getFullYear();
      var maxMonth = n + 1;
      var monthCode = m;
      let startYear = parseInt(this.CadidateWorkExpeiecnceForm.value.startYear);
      if (startYear == maxYear) {
        if (monthCode > maxMonth) {
          return true;
        } else {
          return false;
        }
      }
    } else if (val == "edu") {
      var n = new Date().getMonth();
      var maxYear = new Date().getFullYear();
      var maxMonth = n + 1;
      var monthCode = m;
      let startYear = parseInt(this.CadidateEducationForm.value.startYear);
      if (startYear == maxYear) {
        if (monthCode > maxMonth) {
          return true;
        } else {
          return false;
        }
      }
    } else if (val == "cert") {
      var n = new Date().getMonth();
      var maxYear = new Date().getFullYear();
      var maxMonth = n + 1;
      var monthCode = m;
      let startYear = parseInt(this.CadidateCerificationForm.value.startYear);
      if (startYear == maxYear) {
        if (monthCode > maxMonth) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
  checkYear(y, val) {
    // ////
    if (val == "exp") {
      let yearDataInt = parseInt(this.CadidateWorkExpeiecnceForm.value.startYear);
      let year = parseInt(y);
      if (yearDataInt != null) {
        if (yearDataInt > year) {
          return true;
        } else {
          return false;
        }
      }
    } else if (val == "edu") {
      let yearDataInt = parseInt(this.CadidateEducationForm.value.startYear);
      let year = parseInt(y);
      if (yearDataInt != null) {
        if (yearDataInt > year) {
          return true;
        } else {
          return false;
        }
      }
    } else if (val == "cert") {
      let yearDataInt = parseInt(this.CadidateCerificationForm.value.startYear);
      let year = parseInt(y);
      if (yearDataInt != null) {
        if (yearDataInt > year) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
  validateOtp(){
    this.defineDomainErrors();
    if(this.domainForm.value.domainValidationOtp==null  || this.domainForm.value.domainValidationOtp==''){
      this.domainForm.get('domainValidationOtp').setErrors({wrongOtp : false})
     }
    else{
        this.domainForm.get('domainValidationOtp').setErrors({wrongOtp :false})
        this.util.startLoader();
         let data : any ={}
        data.businessId = this.userId;
        data.entityId = this.userId;
        data.otp = this.domainForm.value.domainValidationOtp;
        data.primaryMailId =  this.domainForm.value.businessemail;
        data.secondaryMailId = this.previousMailId
        this.api.create('user/verifyOTPToPrimaryMailId',data).subscribe(res=>{
          this.util.stopLoader();
            if(res.code=="00000"){
              this.domainForm.get('domainValidationOtp').setErrors({wrongOtp :false})
              Swal.fire({
                position: "center",
                icon: "success",
                title: "OTP verified successfully.",
                showConfirmButton: false,
                timer: 2000,
              })
                this.checkWorkModel = 'saveAfterOtp';
                this.workExperSave();
            }
            else if (res.code=="99998"){
               this.domainForm.get('domainValidationOtp').setErrors({wrongOtp :true})
              this.util.stopLoader();
              this.resenOtp=false;
             }
        })
    }
  }
  get domainControl(){
    return this.domainForm.controls;
   }
  checkMailExists(email:string){
    this.emailvalid =null
    this.defineDomainErrors();
    if(this.domainForm.value.businessemail==null  || this.domainForm.value.businessemail=='' && email.length==0 || email ==""){
      this.domainForm.get('businessemail').setErrors({emailExists : false})
     }
    else{
          this.domainForm.get('businessemail').setErrors({emailExists : false});
          this.api.query("user/checkMailAlreadyExists/" + email).subscribe((res) => {
        if(res.code=="00000"){
          if (res.data.exists) {
           this.domainForm.get('businessemail').setErrors({emailExists : true});
          } else if(res.data.exists==false){
           this.domainForm.get('businessemail').setErrors({emailExists : false});
           }
         }
       })
    }
  }
  onLogout() {
    var val: any = {}
    val.isLoggedOut = true
    this.searchData.setCommonVariables(val);
    this.util.startLoader();
    this.api.onLogout().subscribe((res) => {
      if (res) {
        if (res.code === "00000") {
          this.util.stopLoader();
          //this.updateUserOnlineOrOffline('OFFLINE');
          this.onLogoutSuccess();
        } else {
          this.util.stopLoader();
        }
      }
    });
  }
  organizationList : Array<any> = []
  searchBarShow : boolean = false
  getOrganization(val){
    if(val!=null){
      this.util.startLoader();
        this.api.query("care/organizations?organizationName=" + val)
         .subscribe((res) => {
          this.util.stopLoader();
          this.organizationList=[]
            res.forEach(ele => {
              this.organizationList.push(ele);
             });
         });
         this.searchBarShow = true;
    }
    else{
      this.searchBarShow = false
    }
  }

  organizationPayload = {
    name: "",
    limit: 10,
    page: 0
  };
  orgStopScroll: boolean = false;

  getOrgList(value: string) {
    this.organizationPayload.name = value;
    if (value.trim().length >= 0 && value != " ") {
      // No full-page loader here: this fires on every keystroke while the user
      // types in the Organisation ng-select, and a blocking spinner interrupted
      // the open dropdown (the field "reloaded" mid-selection and flashed the
      // required error). The fetch just refreshes the suggestion list.
      this.api.query(`care/findSuggestionsByOrgName?organizationName=${this.organizationPayload.name}&page=${this.organizationPayload.page}&limit=${this.organizationPayload.limit}`)
        .subscribe({
          next: (res) => {
            if (res != null) {
              // Filter out duplicates based on organizationId when adding new results
              const filteredResults = res.filter(newOrg =>
                !this.organizationList.some(existingOrg =>
                  existingOrg.organizationId === newOrg.organizationId
                )
              );
              this.organizationList = [...this.organizationList, ...filteredResults];
            } else if (res && (res.length === 0 || this.organizationPayload.limit != res.length)) {
              this.orgStopScroll = true;
              this.organizationList = [];
            }
          },
          error: (err) => {
          },
        });

      this.searchBarShow = true;
    } else {
      this.searchBarShow = false
    }
  }

  onScrollDown() {
    if (!this.orgStopScroll) {
      this.organizationPayload.page += 1;
      // The plain input writes straight to the control, so the live term IS the
      // control value (same as the profile modal's typeahead).
      this.getOrgList(this.workFromControl.organisationName.value || '');
    }
  }

  uniqueOrgTrack(index, item) {
    return item.organizationId;
  }

  showOrgListAgain() {
    this.searchBarShow = true;
  }


  onchangeEdu(element){
    this.CadidateEducationForm.patchValue({
            country : element.country,
            city : element.city,
            state : element.state,
            zipcode : element.zipCode
    })
  }

  // School ng-select — fired as the user types. Tracks the live term and
  // queries the institutions endpoint to populate the suggestion list.
  onSchoolSearch(event: { term: string; items: any[] }) {
    const term = event?.term ?? '';
    this.currentSchoolSearch = term;
    // Mirror the Organisation fix: ng-select fires (search) with an EMPTY term
    // the instant a suggestion is picked or a new college is added via addTag.
    // Running searchSchool('') there set schoolData = [], so the just-added
    // college dropped out of [items] and — because bindValue="institutionName"
    // resolves the value from that list — the added name was lost and never
    // reached the submit payload ("added college not saved"). Only search on a
    // real term so the added/selected college stays in the list and is saved.
    if (term.trim().length > 0) {
      this.searchSchool(term);
    }
  }

  searchSchool(term: string) {
    if (!term) {
      this.schoolData = [];
      return;
    }
    // No full-page loader: this fires per keystroke while typing in the School
    // ng-select, and a blocking spinner interrupted the open dropdown. The
    // fetch just refreshes the suggestion list.
    this.api.query("care/intitutions/" + term).subscribe((res) => {
      this.schoolData = res || [];
    }, err => {
      this.schoolData = [];
    });
  }

  // School ng-select — fired on selection (or free-text tag add). bindValue=
  // "institutionName" means $event is the school NAME string; look the full
  // object up to drive the address auto-fill (same as onchangeEdu). A typed
  // (free-text) school isn't in the list → no auto-fill.
  /** Location (country / state / city / zipcode) is authoritative from the
   *  institution master, so it is auto-filled and LOCKED when an existing
   *  college is chosen. A newly-typed college has no master record, so the
   *  user must be able to type its location.
   *  NOTE: country/state are <select>s, so `readonly` doesn't apply — we must
   *  disable() the controls. Disabled controls are omitted from `form.value`,
   *  which is why the education saves read `getRawValue()` instead. */
  private setEducationLocationEditable(editable: boolean): void {
    // Picking an existing institution from the suggestions auto-fills its
    // authoritative location, so LOCK (disable) the location fields — the user must
    // not edit a master college's address. A newly-typed (free-text) college has no
    // master location, so the fields stay enabled for the user to type.
    //   editable === true  → free-text / no pick → enable
    //   editable === false → existing institution picked → disable (locked)
    // NOTE: country/state are <select>s, so `readonly` doesn't apply — we must
    // disable() the controls. Disabled controls are dropped from `form.value`, which
    // is why the education save reads getRawValue() (see the submit handlers).
    ['country', 'state', 'city', 'zipcode', 'street'].forEach((name) => {
      const ctrl = this.CadidateEducationForm?.get(name);
      if (!ctrl) { return; }
      if (editable) {
        ctrl.enable({ emitEvent: false });
      } else {
        ctrl.disable({ emitEvent: false });
      }
    });
  }

  /** Work-experience location lock, mirroring setEducationLocationEditable.
   *  Picking an existing organisation from the suggestions auto-fills its
   *  authoritative address, so LOCK (disable) the location fields. Editing the
   *  organisation name (typing) means a different / new org, so UNLOCK them.
   *    editable === true  → free-text / edited name → enable
   *    editable === false → existing organisation picked → disable (locked)
   *  country/state are <select>s (no readonly), so we disable() the controls;
   *  disabled controls drop from form.value, which is why the work-experience
   *  saves read getRawValue(). */
  private setWorkLocationEditable(editable: boolean): void {
    ['country', 'state', 'city', 'zipcode'].forEach((name) => {
      const ctrl = this.CadidateWorkExpeiecnceForm?.get(name);
      if (!ctrl) { return; }
      if (editable) {
        ctrl.enable({ emitEvent: false });
      } else {
        ctrl.disable({ emitEvent: false });
      }
    });
  }

  // ── School / College typeahead (plain <input>, like the profile page) ──────
  // Async source: ngx-bootstrap re-subscribes on each keystroke, so we read the
  // current term and hit the SAME per-keystroke server search this field already
  // used (care/intitutions/<term>) — a small, filtered result set.
  //
  // We deliberately do NOT use getInstitutions() / `care/institutions` here.
  // That loads the ENTIRE institution master and is what froze the page before
  // (it also has a latent bug: stopLoader() only runs inside `if (res)`).
  // No blocking loader is used here, and errors fall back to an empty list, so
  // this can never wedge the UI.
  schoolSuggestions$: Observable<any[]>;

  private initSchoolSuggestions(): void {
    this.schoolSuggestions$ = new Observable<string>((observer) => {
      observer.next(this.CadidateEducationForm?.get('schoolName')?.value ?? '');
    }).pipe(
      switchMap((term: string) => {
        const q = (term ?? '').toString().trim();
        if (!q) { return of([]); }
        return this.api.query('care/intitutions/' + q).pipe(
          map((res: any) => (Array.isArray(res) ? res : [])),
          catchError(() => of([])),
          map((master: any[]) => this.withCandidateOwnSchools(master, q))
        );
      })
    );
  }

  /** The typeahead only searches the institution MASTER. A college typed as
   *  free-text is saved onto the candidate's education record but never
   *  registered in the master, so re-using it on a new entry surfaced no
   *  suggestion and therefore fetched no location. Fold the candidate's own
   *  previously-entered schools into the results so re-using one prefills the
   *  location they already provided.
   *  (The real fix is the backend registering new institutions on
   *  institutionId: null — this just stops the gap being user-visible.) */
  private withCandidateOwnSchools(master: any[], term: string): any[] {
    const q = (term || '').toLowerCase();
    const list = Array.isArray(master) ? master : [];
    const seen = new Set(
      list.map((m: any) => (m?.institutionName ?? '').toString().toLowerCase())
    );
    const own: any[] = [];
    (this.CandidateData?.educationDetails ?? []).forEach((e: any) => {
      const name = (e?.schoolName ?? '').toString();
      const key = name.toLowerCase();
      // Skip blanks, non-matches, and anything the master already returned.
      if (!name || !key.includes(q) || seen.has(key)) { return; }
      seen.add(key);
      own.push({
        institutionName: name,
        // No institutionId → stays a free-text college, so the location is a
        // prefill the user can still edit (see onChangeSchool).
        institutionId: e.institutionId ?? null,
        country: e.country ?? null,
        state: e.state ?? null,
        city: e.city ?? null,
        zipCode: e.zipcode ?? null,
        street: e.street ?? null,
      });
    });
    return [...list, ...own];
  }

  /** An EXISTING institution was picked from the suggestions. Link it by id and
   *  auto-fill + lock its location (that data is authoritative from the master). */
  /** Name of the master institution currently selected, so changeTypeaheadNoResults
   *  can tell "the typeahead re-queried after we wrote the name back" (ignore)
   *  from "the user edited the name into something new" (unlock + clear id). */
  private selectedInstitutionName: string | null = null;

  onChangeSchool(event: any): void {
    const item = event?.item;
    if (!item) { return; }
    const name = (item.institutionName ?? '').toString().trim();

    this.CadidateEducationForm.patchValue({
      schoolName: name,
      institutionId: item.institutionId ?? null,
    });
    // Remember the pick (any suggestion, not just master ones) so a stray
    // noResults from the typeahead can't clear it — see changeTypeaheadNoResults.
    this.selectedInstitutionName = name;

    if (item.institutionId) {
      // Existing MASTER institution → fetch its authoritative address, exactly
      // like the profile page does (care/intitutions/{name}/{institutionId}),
      // showing the loader while it resolves.
      this.util.startLoader();
      this.api.query('care/intitutions/' + name + '/' + item.institutionId).subscribe(
        (res: any) => {
          this.util.stopLoader();
          const detail = Array.isArray(res) ? res[0] : res;
          if (detail) {
            this.patchEducationLocation(detail);
          } else {
            // Endpoint returned nothing — fall back to the suggestion's own data.
            this.patchEducationLocation(item);
          }
          this.setEducationLocationEditable(false);
        },
        () => {
          // stopLoader() must run on EVERY path — an unbalanced loader is what
          // froze this page before.
          this.util.stopLoader();
          this.patchEducationLocation(item);
          this.setEducationLocationEditable(false);
        }
      );
      return;
    }

    // Legacy candidate-only college (no master id, surfaced by
    // withCandidateOwnSchools) → nothing to fetch; use the location carried on
    // the suggestion. The null id still makes the backend's resolveInstitution()
    // register it in the master on save.
    this.patchEducationLocation(item);
    // Picking ANY suggestion means choosing an existing record, so its location
    // is known and must be locked. Only a genuinely typed, unmatched name
    // unlocks (see changeTypeaheadNoResults).
    this.setEducationLocationEditable(false);
  }

  /** Patch the education location from an institution detail/suggestion.
   *  NOTE the field-name shift: the institution uses `zipCode`, the education
   *  form uses `zipcode`. */
  private patchEducationLocation(src: any): void {
    // Use `|| null`, NOT `?? null`: institution master records can carry an
    // EMPTY STRING for a missing state/country (e.g. a US college with no state),
    // and `??` lets "" through. "" matches neither the `[ngValue]="null"`
    // placeholder option nor any real option, so the <select> renders a blank
    // phantom and the "State" placeholder vanishes (reported: pick an India
    // college, then switch to a US one → State placeholder gone). Coalescing ""
    // to null lets the value match the placeholder again. See
    // select-null-placeholder-pattern.
    this.CadidateEducationForm.patchValue({
      country: src?.country || null,
      // Don't trust the raw state here — it may name a state that doesn't belong
      // to this country (e.g. school record with US + "Tamilnadu"). Start null and
      // let loadStatesForCountry apply it ONLY if it exists in the loaded list;
      // otherwise the field keeps its "State" placeholder instead of blanking.
      state: null,
      city: src?.city || null,
      zipcode: src?.zipCode || null,
      street: src?.street || null,
    });
    // Reload the State options for the auto-filled country AND reconcile the
    // state value against them — patchValue above doesn't fire the Country
    // (change) handler, so without this the <select> would keep the previous
    // country's states (see loadStatesForCountry).
    this.loadStatesForCountry(src?.country || null, false, src?.state || null, this.CadidateEducationForm);
  }

  /** Typed school matches no institution → it's a NEW (free-text) college. Drop
   *  any linked institutionId (a null id is what tells the backend to register a
   *  new institution) and let the user type the location. */
  changeTypeaheadNoResults(noResults: boolean): void {
    if (!noResults) { return; }
    const current = (this.CadidateEducationForm?.get('schoolName')?.value ?? '')
      .toString().trim();
    // Guard the race: onChangeSchool patches schoolName back into the input,
    // which re-fires the typeahead and can emit noResults right AFTER a valid
    // pick — that would clear institutionId and re-enable the location, undoing
    // the selection (the reported "location still editable"). While the name
    // still matches the institution just chosen, this event is not a real
    // "no match" — ignore it.
    if (this.selectedInstitutionName && current === this.selectedInstitutionName) {
      return;
    }
    // The name genuinely differs from any master institution → free-text college.
    this.selectedInstitutionName = null;
    this.CadidateEducationForm.get('institutionId')?.setValue(null);
    this.setEducationLocationEditable(true);
  }

  /** Fired on every keystroke in the School-name input. Once an institution has
   *  been picked (location auto-filled and LOCKED), editing the name away from the
   *  chosen college means the user is describing a DIFFERENT / NEW institution — so
   *  drop the linked institutionId and UNLOCK the location, letting them enter a new
   *  address (the backend registers a new institution on save when institutionId is
   *  null). This complements changeTypeaheadNoResults, which only fires when the
   *  typed name matches nothing; here we react even while suggestions still show.
   *
   *  Runs only on real DOM typing — onChangeSchool patches the name via patchValue,
   *  which does NOT dispatch an input event, so re-selecting can't be undone here. */
  onSchoolNameChanged(): void {
    // Nothing was locked in yet → free-text typing, location already editable.
    if (!this.CadidateEducationForm?.get('institutionId')?.value) { return; }
    const current = (this.CadidateEducationForm?.get('schoolName')?.value ?? '')
      .toString().trim();
    // Still exactly the picked college → keep the selection and the lock.
    if (this.selectedInstitutionName && current === this.selectedInstitutionName) {
      return;
    }
    // Name diverged from the pick → treat as a new institution.
    this.selectedInstitutionName = null;
    this.CadidateEducationForm.get('institutionId')?.setValue(null);
    this.setEducationLocationEditable(true);
  }

  onSchoolSelect(selected: any) {
    if (!selected) {
      // Cleared → no linked institution; let the user type a location again.
      this.CadidateEducationForm.get('institutionId')?.setValue(null);
      this.setEducationLocationEditable(true);
      return;
    }
    const name = (typeof selected === 'object') ? selected.institutionName : selected;
    const obj = (typeof selected === 'object')
      ? selected
      : (Array.isArray(this.schoolData) ? this.schoolData.find(s => s.institutionName === name) : null);
    if (obj && obj.institutionId) {
      // Known institution from the master → link it by id and auto-fill its
      // address. (Previously institutionId was NEVER set, so even known
      // colleges were submitted with a null id and couldn't be linked.)
      this.CadidateEducationForm.patchValue({
        institutionId: obj.institutionId,
        country: obj.country || null,
        city: obj.city || null,
        state: obj.state || null,
        zipcode: obj.zipCode || null
      });
      // Existing college → the fetched location is authoritative, lock it.
      this.setEducationLocationEditable(false);
    } else {
      // Newly typed (free-text) college — NOT in the master. Clear any stale
      // institutionId (e.g. left over from editing an existing entry or a
      // prior selection). Without this the backend linked the new name to that
      // old institution, so the typed college was never registered in the
      // master and never reappeared in the dropdown for future use. A null id
      // tells the backend to register it as a new institution.
      this.CadidateEducationForm.get('institutionId')?.setValue(null);
      // Newly typed college → no master record to fetch a location from, so
      // the user has to enter it.
      this.setEducationLocationEditable(true);
    }
  }
  onChangeorg(value ){
    this.searchBarShow = false;
    var data = value.organizationName + "/" + value.organizationId;
    this.workFromControl.organisationName.setValue(value.organizationName);
    this.workFromControl.organisationId.setValue(value.organizationId);
    // Existing org picked → its address is authoritative, LOCK the location.
    // (the patchValue below still writes the disabled controls, and the save
    // reads getRawValue(), so the locked location is still submitted.)
    this.setWorkLocationEditable(false);
    this.api.query("care/organization/" + data).subscribe(res=>{
      if(res){
        res.forEach(element => {
          // Coalesce to null — the Location placeholders are
          // [ngValue]="null" options and `undefined` doesn't match null,
          // so an org without location data would blank the selects
          // (same fix onSchoolSelect got on the Education form).
          // Country must be the countryCode (the <select>'s option value AND what
          // getAllStates needs), not the display name.
          const country = ((element.countryCode || element.country || '') + '').trim() || null;
          const stateVal = ((element.state || '') + '').trim() || null;
          this.CadidateWorkExpeiecnceForm.patchValue({
            country : country,
            city : element.city || null,
            // Start null; loadStatesForCountry reconciles the value against the
            // loaded options (apply only if the state belongs to this country),
            // so an org with e.g. US + "Tamilnadu" won't blank the field.
            state : null,
            zipcode : element.zipCode || null
          });
          this.loadStatesForCountry(country, true, stateVal, this.CadidateWorkExpeiecnceForm);
        });
      }
      console.log("form" , this.CadidateWorkExpeiecnceForm);

    });
  }
  onLogoutSuccess() {
    this.cookieService.deleteAll();
    let allCookies = document.cookie.split(";");
    if (allCookies) {
      for (let i = 0; i < allCookies.length; i++) {
        document.cookie =
          allCookies[i] + "=;expires=" + new Date(0).toUTCString();
      }
    }
    localStorage.clear();
    this._socket.ngOnDestroy();
    this._socket_stream.ngOnDestroy();
setTimeout(() => {
	    this.router.navigate(["auth/login"]);
}, 2000);  }
  onChangeYear(val) {
    const maxyr = new Date().getFullYear();
    if (val == "exp") {
      if (
        this.CadidateWorkExpeiecnceForm.value.startYear ==
        this.CadidateWorkExpeiecnceForm.value.endYear ||
        this.CadidateWorkExpeiecnceForm.value.endYear == maxyr
      ) {
        this.CadidateWorkExpeiecnceForm.patchValue({ endMonth: null });
      }
      if (
        this.CadidateWorkExpeiecnceForm.value.startYear ==
        this.CadidateWorkExpeiecnceForm.value.endYear
      ) {
        this.validateMonth = true;
      } else {
        this.validateMonth = false;
      }
    } else if (val == "edu") {
      if (
        this.CadidateEducationForm.value.startYear ==
        this.CadidateEducationForm.value.endYear ||
        this.CadidateEducationForm.value.endYear == maxyr
      ) {
        this.CadidateEducationForm.patchValue({ endMonth: null });
      }
      if (
        this.CadidateEducationForm.value.startYear ==
        this.CadidateEducationForm.value.endYear
      ) {
        // this.validateEduMonth = true;
      } else {
        // this.validateEduMonth = false;
      }
    } else if (val == "cert") {
      if (
        this.CadidateCerificationForm.value.startYear ==
        this.CadidateCerificationForm.value.endYear ||
        this.CadidateCerificationForm.value.endYear == maxyr
      ) {
        this.CadidateCerificationForm.patchValue({ endMonth: null });
      }
      if (
        this.CadidateCerificationForm.value.startYear ==
        this.CadidateCerificationForm.value.endYear
      ) {
        // this.validateCertMonth = true;
      } else {
        // this.validateCertMonth = false;
      }
    }
  }
  checkMonth(m, val) {
    var max = new Date().getFullYear();
    if (val == "exp") {
      let endyr = parseInt(this.CadidateWorkExpeiecnceForm.value.endYear);
      let stMonth = this.CadidateWorkExpeiecnceForm.value.startMonth;
      let styr = parseInt(this.CadidateWorkExpeiecnceForm.value.startYear);
      let stMonthCode;
      let n = new Date().getMonth();
      let monthCode = m;
      this.months.forEach((e) => {
        if (e.name == stMonth) {
          stMonthCode = e.code;
        }
      });
      if (styr == max && (this.validateMonth || styr == endyr)) {
        if (monthCode > n + 1 || stMonthCode > monthCode) {
          return true;
        } else {
          return false;
        }
      } else if (styr != max && (this.validateMonth || styr == endyr)) {
        if (stMonthCode > monthCode) {
          return true;
        } else {
          return false;
        }
      } else if (styr != endyr && endyr == max) {
        if (monthCode > n + 1) {
          return true;
        } else {
          return false;
        }
      }
    } else if (val == "edu") {
      let endyr = parseInt(this.CadidateEducationForm.value.endYear);
      let stMonth = this.CadidateEducationForm.value.startMonth;
      let styr = parseInt(this.CadidateEducationForm.value.startYear);
      let stMonthCode;
      let n = new Date().getMonth();
      let monthCode = m;
      this.months.forEach((e) => {
        if (e.name == stMonth) {
          stMonthCode = e.code;
        }
      });
      if (styr == max && (this.validateMonth || styr == endyr)) {
        if (monthCode > n + 1 || stMonthCode > monthCode) {
          return true;
        } else {
          return false;
        }
      } else if (styr != max && (this.validateMonth || styr == endyr)) {
        if (stMonthCode > monthCode) {
          return true;
        } else {
          return false;
        }
      } else if (styr != endyr && endyr == max) {
        if (monthCode > n + 1) {
          return true;
        } else {
          return false;
        }
      }
    } else if (val == "cert") {
      let endyr = parseInt(this.CadidateCerificationForm.value.endYear);
      let stMonth = this.CadidateCerificationForm.value.startMonth;
      let styr = parseInt(this.CadidateCerificationForm.value.startYear);
      let stMonthCode;
      let n = new Date().getMonth();
      let monthCode = m;
      this.months.forEach((e) => {
        if (e.name == stMonth) {
          stMonthCode = e.code;
        }
      });
      if (styr == max && (this.validateMonth || styr == endyr)) {
        if (monthCode > n + 1 || stMonthCode > monthCode) {
          return true;
        } else {
          return false;
        }
      } else if (styr != max && (this.validateMonth || styr == endyr)) {
        if (stMonthCode > monthCode) {
          return true;
        } else {
          return false;
        }
      } else if (styr != endyr && endyr == max) {
        if (monthCode > n + 1) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
  yearChange(event, val) {
    if (val == "exp") {
      var stYr = parseInt(this.CadidateWorkExpeiecnceForm.value.startYear);
      var maxYr = new Date().getFullYear();
      if (stYr == maxYr) {
        this.CadidateWorkExpeiecnceForm.patchValue({ startMonth: null });
      }
      this.yearData = event.target.value;
      // this.yearIndex = index;
      this.CadidateWorkExpeiecnceForm.patchValue({
        endYear: this.currentYear,
        endMonth: null,
      });
    } else if (val == "edu") {
      var stYr = parseInt(this.CadidateEducationForm.value.startYear);
      var maxYr = new Date().getFullYear();
      if (stYr == maxYr) {
        this.CadidateEducationForm.patchValue({ startMonth: null });
      }
      this.yearData = event.target.value;
      // this.yearIndex = index;
      this.CadidateEducationForm.patchValue({
        endYear: this.currentYear,
        endMonth: null,
      });
    } else if (val == "cert") {
      var stYr = parseInt(this.CadidateCerificationForm.value.startYear);
      var maxYr = new Date().getFullYear();
      if (stYr == maxYr) {
        this.CadidateCerificationForm.patchValue({ startMonth: null });
      }
      this.yearData = event.target.value;
      // this.yearIndex = index;
      this.CadidateCerificationForm.patchValue({
        endYear: this.currentYear,
        endMonth: null,
      });
    }
  }
  // Adapter for the Certifications "Issue Date → Year" ng-select. Mirrors
  // yearChange(event,'cert') but reads startYear from the form control, since
  // ng-select emits the selected item (not a DOM event) on (change). Keeps the
  // same side effects: clear startMonth when the start year is the current year,
  // and reset the expiration date to the current year / blank month.
  certStartYearChange() {
    const stYr = parseInt(this.CadidateCerificationForm.value.startYear);
    const maxYr = new Date().getFullYear();
    if (stYr == maxYr) {
      this.CadidateCerificationForm.patchValue({ startMonth: null });
    }
    this.yearData = this.CadidateCerificationForm.value.startYear;
    this.CadidateCerificationForm.patchValue({
      endYear: this.currentYear,
      endMonth: null,
    });
  }
  // Adapter for the Work Experience "From Date → Year" ng-select. Mirrors
  // yearChange(event,'exp') but reads startYear from the form control, since
  // ng-select emits the selected item (not a DOM event) on (change).
  expStartYearChange() {
    const stYr = parseInt(this.CadidateWorkExpeiecnceForm.value.startYear);
    const maxYr = new Date().getFullYear();
    if (stYr == maxYr) {
      this.CadidateWorkExpeiecnceForm.patchValue({ startMonth: null });
    }
    this.yearData = this.CadidateWorkExpeiecnceForm.value.startYear;
    this.CadidateWorkExpeiecnceForm.patchValue({
      endYear: this.currentYear,
      endMonth: null,
    });
  }
  // Adapter for the Education "From Date → Year" ng-select. Mirrors
  // yearChange(event,'edu') but reads startYear from the form control, since
  // ng-select emits the selected item (not a DOM event) on (change).
  eduStartYearChange() {
    const stYr = parseInt(this.CadidateEducationForm.value.startYear);
    const maxYr = new Date().getFullYear();
    if (stYr == maxYr) {
      this.CadidateEducationForm.patchValue({ startMonth: null });
    }
    this.yearData = this.CadidateEducationForm.value.startYear;
    this.CadidateEducationForm.patchValue({
      endYear: this.currentYear,
      endMonth: null,
    });
  }
  removeWorkExperience(values){
   this.editData=values;
    if(this.userType == 'student' || this.userType == 'JOB_SEEKER') {
      if(values.currentOrganization==true){
        this.util.startLoader();
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {confirmButton: "btn btn-success"},
          buttonsStyling: false,
        });
         swalWithBootstrapButtons
          .fire({
            title: "Sorry, you can't delete this.",
            text: "This work place is being shown on your profile.",
            icon: "warning",
            confirmButtonText: "Okay",
          });
          this.util.stopLoader();
      }
      else{
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger'
          },
          buttonsStyling: false
        })
        swalWithBootstrapButtons.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true
        }).then((result)=>{
            if(result.isConfirmed){
              this.util.startLoader();
               this.api.create("user/remove/workexp",values).subscribe(res=>{
                if(res.code="00000"){
                  this.util.stopLoader();
                   // Remove the entry that was actually deleted (by expId).
                   // Using pop() here removed the last row regardless of match.
                   this.CandidateData.workExperiences = this.CandidateData.workExperiences.filter(
                     (element) => element.expId != values.expId
                   );
                   this.showDetailSaveSuccess('Work experience removed successfully');
                }
                this.util.stopLoader();
               });
            }
          })
      }
    }
    else {
        this.removeCandidateWorkExperience(values);
    }
  }
  workexpEdit(template: TemplateRef<any>, item, value) {
    this.checkWorkModel =value
    this.CadidateWorkExpeiecnceForm.reset();
    this.editData = item;
    this.modalRef = this.modalService.show(template, this.backdropConfig);

    this.CadidateWorkExpeiecnceForm.patchValue(item);
    // patchValue doesn't fire the Country (change) event, so the State options
    // never load and the field falls back to the free-text <input>. Load the
    // saved country's states and reconcile the saved state against them — same
    // validated load the org-select paths use (keeps a valid state, drops one
    // that no longer belongs to the country instead of blanking the <select>).
    this.loadStatesForCountry(item?.country || null, true, item?.state || null, this.CadidateWorkExpeiecnceForm);
    // The Organisation field is a plain input, so patchValue above already
    // renders the saved name — no need to seed a suggestion list, and seeding
    // it would show that single org as a phantom suggestion on focus.
    this.organizationList = [];
    // Linked to a master organisation → its location is authoritative, keep it
    // locked. A free-text org (no organisationId) stays editable.
    this.setWorkLocationEditable(!item?.organisationId);
    // Sync the end-date validators with the current-organization state, the
    // same way curOrg() does on add. A current org has no end date, so its
    // endMonth/endYear are null; without clearing the required validators the
    // form stays invalid and the Submit button silently does nothing on edit.
    const endMonth = this.CadidateWorkExpeiecnceForm.get('endMonth');
    const endYear = this.CadidateWorkExpeiecnceForm.get('endYear');
    if (item?.currentOrganization === true || item?.currentOrganization === 'true') {
      endMonth.clearValidators();
      endYear.clearValidators();
    } else {
      endMonth.setValidators([Validators.required]);
      endYear.setValidators([Validators.required]);
    }
    endMonth.updateValueAndValidity();
    endYear.updateValueAndValidity();
  }
  removeCandidateWorkExperience(item) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure you want to remove?",
        text: "You won't be able to revert this",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
      })
      .then((result) => {
        if(result.isConfirmed){
            item.streamAction = "REMOVE";
        this.util.startLoader()
        this.api.updatePut('candidates/updateCandidateWorkExperience', item).subscribe((data) => {
        this.util.stopLoader()
          // Remove the entry that was actually deleted (by expId). Using pop()
          // here removed the last row regardless of which one matched.
          this.CandidateData.workExperiences = this.CandidateData.workExperiences.filter(
            (element) => element.expId != item.expId
          );
          this.showDetailSaveSuccess('Work experience removed successfully');
        })
        }
    });
  }
  // Education for JS and Student
  JSEducationSave(){
    let data : any ={}
  if(this.checkEduMOdel=='save'){
    this.submittedEducation = true;
    if (this.CadidateEducationForm.valid || this.CadidateEducationForm.value.currentlyPursued==true && this.CadidateEducationForm.controls.endMonth.errors.required) {
      this.util.startLoader();
       data = this.CadidateEducationForm.getRawValue();
      this.api.create('user/create/education',data).subscribe(res=>{
        this.modalRef.hide();
        let education : Array<any> = res.data.User.educationDetail;
           this.CandidateData.educationDetails.push(education[0]);
           this.CandidateData.educationDetails = this.sortEducationDetails(this.CandidateData.educationDetails);
           this.util.stopLoader();
           this.showDetailSaveSuccess('Education added successfully');
       })
  }
  }
  else if(this.checkEduMOdel=='edit'){
    data = this.CadidateEducationForm.getRawValue();
    if (this.CadidateEducationForm.valid || this.CadidateEducationForm.value.currentlyPursued==true && this.CadidateEducationForm.controls.endMonth.errors.required) {
      this.util.startLoader();
      if(this.editData!=null){
        data.eduId = this.editData.eduId;
       }
      this.api.updatePut('user/update/education',data).subscribe(res=>{
        this.modalRef.hide();
        this.util.stopLoader();
           this.CandidateData.educationDetails.forEach((element,i) => {
              if(element.eduId==this.editData.eduId){
                this.CandidateData.educationDetails[i] = res.data.User.educationDetail[0];
              }
           });
           this.CandidateData.educationDetails = this.sortEducationDetails(this.CandidateData.educationDetails);
           this.showDetailSaveSuccess('Education updated successfully');
       })
    }
  }
}
  checkEduMOdel : string;
  // Education  Part
  EducationFormSave() {
      if(this.userType == 'student' || this.userType == 'JOB_SEEKER') {
        this.JSEducationSave();
        return;
      }
    if(this.checkEduMOdel=='save'){
      this.submittedEducation = true;
      if (this.CadidateEducationForm.valid || this.CadidateEducationForm.value.currentlyPursued==true && this.CadidateEducationForm.controls.endMonth.errors.required) {
        this.util.startLoader();
          let dataPost: any = {};
          // getRawValue(): location controls are disabled (locked) when an existing
          // college is chosen, and disabled controls are omitted from `.value` —
          // which would silently drop country/state/city/zipcode from the payload.
          dataPost = this.CadidateEducationForm.getRawValue();
          dataPost.candidateId = this.candidateDetails.candidateId;
          dataPost.streamAction = "ADD";

           // Convert year fields to strings
           if (dataPost.startYear) dataPost.startYear = String(dataPost.startYear);
           if (dataPost.endYear) dataPost.endYear = String(dataPost.endYear);

           this.modalRef.hide();
           // MUST stay on the candidates endpoint. Candidate education lives in
           // the CANDIDATE store (this page loads it via
           // candidates/findCandidateById -> candidateData.educationDetails),
           // which is a different store from the JOB_SEEKER/student flow (that
           // one loads via user/<userId> and so correctly saves via
           // user/create/education). Saving here through user/create/education
           // would write to the user entity instead — the entry would not come
           // back on reload and would pollute the logged-in user's own profile.
           this.api.updatePut('candidates/updateCandidateEducationalDetail', dataPost).subscribe((res) => {
            this.util.stopLoader();
                this.CandidateData.educationDetails.push(res.data.candidateEducationDetails);
                this.CandidateData.educationDetails = this.sortEducationDetails(this.CandidateData.educationDetails);
                this.showDetailSaveSuccess('Education added successfully');
           });
       }
    }
    else if (this.checkEduMOdel=='edit'){
      this.submittedEducation = true;
      if (this.CadidateEducationForm.valid ||  this.CadidateEducationForm.value.currentlyPursued==true && this.CadidateEducationForm.controls.endMonth.errors.required) {
        this.util.startLoader();
        let dataPost: any = {};
        // getRawValue(): location controls are disabled (locked) when an existing
          // college is chosen, and disabled controls are omitted from `.value` —
          // which would silently drop country/state/city/zipcode from the payload.
          dataPost = this.CadidateEducationForm.getRawValue();
        dataPost.candidateId = this.candidateDetails.candidateId;
        dataPost.streamAction = "ADD";
        if (this.editData != null) {
          dataPost.eduId = this.editData.eduId;
          dataPost.candidateId = this.editData.candidateId;
        }

        // Convert year fields to strings
        if (dataPost.startYear) dataPost.startYear = String(dataPost.startYear);
        if (dataPost.endYear) dataPost.endYear = String(dataPost.endYear);

           this.modalRef.hide();
          // Stays on the candidates endpoint — see the save branch: candidate
          // education is a different store from user education.
          this.api.updatePut('candidates/updateCandidateEducationalDetail', dataPost).subscribe((res) => {
            this.util.stopLoader();
                this.CandidateData.educationDetails.forEach((element,i) => {
                    if(element.eduId==this.editData.eduId){
                      this.CandidateData.educationDetails[i] = res.data.candidateEducationDetails;
                    }
                });
                this.CandidateData.educationDetails = this.sortEducationDetails(this.CandidateData.educationDetails);
                this.showDetailSaveSuccess('Education updated successfully');
           });
       }
    }
  }
  closeValidator(){
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        denyButton: 'btn btn-danger'
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure you want to close?",
        text: "This will not let you change your current organization.",
        icon: "error",
        // timer: 3000,
        showDenyButton: true,
        confirmButtonText: "Yes",
        denyButtonText: "No"
      }).then((result)=>{
        if(result.isConfirmed){
          this.businessmodal.hide();
        }
      })
  }
  eduEdit(template: TemplateRef<any>, item, value) {
    this.CadidateEducationForm.reset()
    this.checkEduMOdel = value;
    this.editData = item;
    this.modalRef = this.modalService.show(template, this.backdropConfig);
    this.CadidateEducationForm.patchValue(item);
    // patchValue doesn't fire the Country (change) event, so the State options
    // never load and the field falls back to the free-text <input>. Load the
    // saved country's states and reconcile the saved state against them — same
    // validated load the school-select path uses.
    this.loadStatesForCountry(item?.country || null, true, item?.state || null, this.CadidateEducationForm);
    // Seed the School ng-select with the existing value so the pre-filled name
    // renders (ng-select only shows a value that exists in its items).
    //
    // Seed the FULL institution shape (id + location), not just the name: on
    // create the college comes from `care/intitutions/...` carrying
    // institutionId + country/state/city/zipCode, which is what lets
    // onSchoolSelect link it and auto-fill the location. A name-only stub made
    // edit behave differently from create — re-selecting the existing college
    // fell into the "new / free-text" branch (nulling institutionId, so the
    // backend would register a duplicate) and never re-filled the location.
    // NOTE: the education record stores `zipcode`, the institution object uses
    // `zipCode` — map it so onSchoolSelect's `obj.zipCode` resolves.
    if (item?.schoolName) {
      this.schoolData = [{
        institutionName: item.schoolName,
        institutionId: item.institutionId ?? null,
        country: item.country ?? null,
        state: item.state ?? null,
        city: item.city ?? null,
        zipCode: item.zipcode ?? null,
        street: item.street ?? null,
      }];
      this.currentSchoolSearch = item.schoolName;
    }
    // Linked to a master institution → its location is authoritative, keep it
    // locked. A free-text college (no institutionId) stays editable.
    this.setEducationLocationEditable(!item?.institutionId);
    // Treat an already-linked entry as "selected" so a stray noResults from the
    // typeahead can't clear its institutionId / unlock its location on open.
    this.selectedInstitutionName = item?.institutionId
      ? (item?.schoolName ?? '').toString().trim()
      : null;
  }
  removeEducation(item:any) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure you want to remove?",
        text: "You won't be able to revert this",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
      })
      .then((result) => {
        if(result.isConfirmed){
          if(this.userType == 'student' || this.userType == 'JOB_SEEKER') {
            this.JSremoveEducation(item);
            return;
          }
          item.streamAction = 'REMOVE';
          this.util.startLoader();
          this.api.updatePut('candidates/updateCandidateEducationalDetail', item).subscribe((data) => {
            this.util.stopLoader();
           // Remove the entry that was actually deleted (by eduId).
           this.CandidateData.educationDetails = this.CandidateData.educationDetails.filter(
             (element) => element.eduId != item.eduId
           );
           this.showDetailSaveSuccess('Education removed successfully');
          })
        }
      });
  }
  JSremoveEducation(value){
    this.api.create("user/remove/education",value).subscribe(res=>{
      // Remove the entry that was actually deleted (by eduId).
      this.CandidateData.educationDetails = this.CandidateData.educationDetails.filter(
        (element) => element.eduId != value.eduId
      );
      this.showDetailSaveSuccess('Education removed successfully');
    })
  }
  JScertiificatiobnsave(){
    if(this.checkcertificationmodel=='save'){
      this.submittedCertification = true;
      if(this.CadidateCerificationForm.valid){
        this.util.startLoader();
         let dataPost: any = {};
         dataPost = this.CadidateCerificationForm.value;
         dataPost.userId = this.userId
       this.modalRef.hide();
       this.api.create('user/create/certification', dataPost).subscribe((res) => {
         this.util.stopLoader();
        this.CandidateData.candidateCertifications.push(res.data.User.certification[0]);
        this.showDetailSaveSuccess('Certification added successfully');
       })
     }
    }
    else if (this.checkcertificationmodel=='edit'){
      this.submittedCertification = true;
      if(this.CadidateCerificationForm.valid){
        this.util.startLoader();
        let dataPost: any = {};
         dataPost = this.CadidateCerificationForm.value;
       if (this.editData != null) {
          dataPost.certificateId = this.editData.certificateId;
        }
       this.modalRef.hide();
        this.api.updatePut('user/update/certification', dataPost).subscribe((res) => {
         this.util.stopLoader();
        this.CandidateData.candidateCertifications.forEach((element,i) => {
          if(element.certificateId==this.editData.certificateId){
            this.CandidateData.candidateCertifications[i] = res.data.User.certification[0];
          }
        });
        this.showDetailSaveSuccess('Certification updated successfully');
       })
     }
    }
  }
  // cerification's
  certificateFormsave() {
    if(this.userType == 'student' || this.userType == 'JOB_SEEKER') {
      this.JScertiificatiobnsave();
      return;
    }
    if(this.checkcertificationmodel=='save'){
      this.submittedCertification = true;
      if(this.CadidateCerificationForm.valid){
       let dataPost: any = {};
       this.CadidateCerificationForm.value.candidateId = this.candidateDetails.candidateId;
       this.CadidateCerificationForm.value.streamAction = "ADD";
       dataPost = this.CadidateCerificationForm.value;
       if (this.editData != null) {
         dataPost = this.CadidateCerificationForm.value;
         dataPost.certificateId = this.editData.certificateId;
         dataPost.candidateId = this.editData.candidateId;
       }

       // Convert year fields to strings
       if (dataPost.startYear) dataPost.startYear = String(dataPost.startYear);
       if (dataPost.endYear) dataPost.endYear = String(dataPost.endYear);

       this.modalRef.hide();
       this.util.startLoader();
       this.api.updatePut('candidates/updateCandidateCertifications', dataPost).subscribe((res) => {
         this.util.stopLoader();
        this.CandidateData.candidateCertifications.push(res.data.candidateCertificates);
        this.showDetailSaveSuccess('Certification added successfully');
       })
     }
    }
    else if (this.checkcertificationmodel=='edit'){
      this.submittedCertification = true;
      if(this.CadidateCerificationForm.valid){
       let dataPost: any = {};
       this.CadidateCerificationForm.value.candidateId = this.candidateDetails.candidateId;
       this.CadidateCerificationForm.value.streamAction = "ADD";
       dataPost = this.CadidateCerificationForm.value;
       if (this.editData != null) {
         dataPost = this.CadidateCerificationForm.value;
         dataPost.certificateId = this.editData.certificateId;
         dataPost.candidateId = this.editData.candidateId;
       }

       // Convert year fields to strings
       if (dataPost.startYear) dataPost.startYear = String(dataPost.startYear);
       if (dataPost.endYear) dataPost.endYear = String(dataPost.endYear);

       this.modalRef.hide();
       this.util.startLoader();
       this.api.updatePut('candidates/updateCandidateCertifications', dataPost).subscribe((res) => {
         this.util.stopLoader();
        this.CandidateData.candidateCertifications.forEach((element,i) => {
          if(element.certificateId==this.editData.certificateId){
            this.CandidateData.candidateCertifications[i] = res.data.candidateCertificates;
          }
        });
        this.showDetailSaveSuccess('Certification updated successfully');
       })
     }
    }
  }
  checkcertificationmodel : string
  certEdit(template: TemplateRef<any>, item, value) {
    this.CadidateCerificationForm.reset()
    this.editData = item;
    this.checkcertificationmodel = value;
     this.modalRef = this.modalService.show(template, this.backdropConfig);
    this.CadidateCerificationForm.patchValue(item);
  }
  removeCertification(item) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure you want to remove?",
        text: "You won't be able to revert this",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
      })
      .then((result) => {
        if(result.isConfirmed){
          if (this.userType.match("JOB_SEEKER") || !this.userType.match("JOB_SEEKER") && this.userType.match("student") ){
            this.JSremoveCertifications(item);
           }
          else{
            item.streamAction = "REMOVE";
          this.util.startLoader();
          this.api.updatePut('candidates/updateCandidateCertifications', item).subscribe((data) => {
            this.util.stopLoader();
             // Remove the entry that was actually deleted (by certificateId).
             this.CandidateData.candidateCertifications = this.CandidateData.candidateCertifications.filter(
                (element) => element.certificateId != item.certificateId
             );
             this.showDetailSaveSuccess('Certification removed successfully');
          })
          }
        }
      });
  }
JSremoveCertifications(val){
  this.util.startLoader();
  this.api.create('user/remove/certification', val).subscribe((data) => {
     // Remove the entry that was actually deleted (by certificateId).
     this.CandidateData.candidateCertifications = this.CandidateData.candidateCertifications.filter(
        (element) => element.certificateId != val.certificateId
     );
     this.util.stopLoader();
     this.showDetailSaveSuccess('Certification removed successfully');
  });
}
  fromMonthChange(month){
  }
  fromYearChange(year){
  }
  startfromMonthChange(month){
  }
  startYearChange(year){
  }

  hasSpace(value: string): boolean {
    return value?.includes(' ');
  }
}
